import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  Grid,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const MenuCard = ({ menuResults, setSelectedPermissions, selectedPermissions }) => {
  const [checkedPermissions, setCheckedPermissions] = useState([]);

  const handlePermissionChange = (id, permission) => {
    const key = `${id}-${permission}`;
    setCheckedPermissions((prev) =>
      prev.includes(key) ? prev.filter((p) => p !== key) : [...prev, key],
    );
    setSelectedPermissions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const getAllKeys = (menu) => {
    let keys = [];
    if (menu.checkedPermission) {
      menu.checkedPermission.forEach((perm) => {
        keys.push(Object.keys(perm)[0]);
      });
    }
    if (menu.children) {
      menu.children.forEach((child) => {
        if (child.checkedPermission) {
          child.checkedPermission.forEach((perm) => {
            keys.push(Object.keys(perm)[0]);
          });
        }
      });
    }
    return keys;
  };

  const isAllChecked = (keys) => {
    if (!keys || keys.length === 0) return false;
    return keys.every((key) => checkedPermissions.includes(key));
  };

  const isIndeterminate = (keys) => {
    if (!keys || keys.length === 0) return false;
    const checkedCount = keys.filter((key) => checkedPermissions.includes(key)).length;
    return checkedCount > 0 && checkedCount < keys.length;
  };

  const handleSelectAll = (keys, shouldSelect) => {
    const newChecked = shouldSelect
      ? [...new Set([...checkedPermissions, ...keys])]
      : checkedPermissions.filter((p) => !keys.includes(p));

    setCheckedPermissions(newChecked);

    const newSelectedPermissions = { ...selectedPermissions };
    keys.forEach((key) => {
      newSelectedPermissions[key] = shouldSelect;
    });
    setSelectedPermissions(newSelectedPermissions);
  };

  const handleParentSelectAll = (e, menu) => {
    e.stopPropagation();
    const keys = getAllKeys(menu);
    const allChecked = isAllChecked(keys);
    // If it's indeterminate (some checked), we want to select all (make it true)
    // If it's all checked, we want to deselect all (make it false)
    // If it's none checked, we want to select all (make it true)
    // So basically, if (!allChecked) -> Select All.
    handleSelectAll(keys, !allChecked);
  };

  const handleChildSelectAll = (e, submenu) => {
    e.stopPropagation();
    const keys = getAllKeys(submenu); // Recursively gets keys for child (which has no children usually, but works same way)
    const allChecked = isAllChecked(keys);
    handleSelectAll(keys, !allChecked);
  };

  console.log(menuResults, "setMenuResultsollo");

  useEffect(() => {
    if (Object.keys(selectedPermissions).length > 0) {
      // If we already have selected permissions (from parent state), restore them
      const restoredCheckedValues = [];
      Object.keys(selectedPermissions).forEach((key) => {
        if (selectedPermissions[key]) {
          restoredCheckedValues.push(key);
        }
      });
      setCheckedPermissions(restoredCheckedValues);
    } else {
      // Otherwise, initialize from menuResults as default
      const checkedValues = [];
      for (const i in menuResults) {
        const parentKeys = Object.keys(menuResults[i]["checkedPermission"][0]);
        console.log(parentKeys, "parentKeys");
        if (menuResults[i]["checkedPermission"][0][parentKeys[0]]) {
          checkedValues.push(parentKeys[0]);
        }
        setSelectedPermissions((prev) => ({
          ...prev,
          [parentKeys[0]]: menuResults[i]["checkedPermission"][0][parentKeys[0]],
        }));

        for (const childIndex in menuResults[i]["children"]) {
          for (const perm in menuResults[i]["children"][childIndex]["checkedPermission"]) {
            const perObj = menuResults[i]["children"][childIndex]["checkedPermission"][perm];
            Object.keys(perObj).forEach((key) => {
              if (perObj[key]) {
                checkedValues.push(key);
              }
              setSelectedPermissions((prev) => ({
                ...prev,
                [key]: perObj[key],
              }));
            });
          }
        }
      }
      console.log(checkedValues, "checkedValues....");
      setCheckedPermissions(checkedValues);
    }
  }, [menuResults]);

  return (
    <Card sx={{ maxWidth: 800, margin: "auto", mt: 4, mb: 4, boxShadow: 3, borderRadius: 2 }}>
      <CardContent>
        {menuResults.map((menu) => (
          <Accordion
            key={menu.menuId}
            sx={{
              mb: 2,
              border: "1px solid #e0e0e0",
              borderRadius: "8px !important",
              "&:before": { display: "none" },
              boxShadow: "none",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark"
                    ? "rgba(255, 255, 255, 0.05)"
                    : "rgba(0, 0, 0, 0.03)",
                borderBottom: (theme) =>
                  theme.palette.mode === "dark"
                    ? "1px solid rgba(255, 255, 255, 0.12)"
                    : "1px solid rgba(0, 0, 0, 0.125)",
              }}
            >
              <FormControlLabel
                onClick={(e) => e.stopPropagation()}
                onFocus={(e) => e.stopPropagation()}
                control={
                  <Checkbox
                    checked={isAllChecked(getAllKeys(menu))}
                    indeterminate={isIndeterminate(getAllKeys(menu))}
                    onChange={(e) => handleParentSelectAll(e, menu)}
                    color="primary"
                  />
                }
                label={
                  <Typography variant="subtitle1" fontWeight="bold">
                    {menu.title}
                  </Typography>
                }
              />
            </AccordionSummary>

            <AccordionDetails sx={{ p: 2 }}>
              <Grid container spacing={2}>
                {menu.checkedPermission?.map((perm) => {
                  const keys = Object.keys(perm);
                  const permssion = keys[0].split("-");
                  return (
                    <Grid item xs={12} sm={6} md={4} key={`${keys[0]}`}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkedPermissions.includes(`${keys[0]}`)}
                            onChange={() => handlePermissionChange(permssion[0], permssion[1])}
                            size="small"
                          />
                        }
                        label={<Typography variant="body2">{permssion[1]}</Typography>}
                      />
                    </Grid>
                  );
                })}
              </Grid>

              {menu.children?.map((submenu) => (
                <Accordion
                  key={submenu.menuId}
                  sx={{
                    mt: 2,
                    border: "1px solid #eee",
                    borderRadius: "4px !important",
                    "&:before": { display: "none" },
                    boxShadow: "none",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                      backgroundColor: (theme) =>
                        theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.05)" : "#fafafa",
                      minHeight: 48,
                    }}
                  >
                    <FormControlLabel
                      onClick={(e) => e.stopPropagation()}
                      onFocus={(e) => e.stopPropagation()}
                      control={
                        <Checkbox
                          checked={isAllChecked(getAllKeys(submenu))}
                          indeterminate={isIndeterminate(getAllKeys(submenu))}
                          onChange={(e) => handleChildSelectAll(e, submenu)}
                          size="small"
                        />
                      }
                      label={
                        <Typography variant="body2" fontWeight="medium">
                          {submenu.title}
                        </Typography>
                      }
                    />
                  </AccordionSummary>

                  <AccordionDetails
                    sx={{
                      bgcolor: (theme) =>
                        theme.palette.mode === "dark" ? "background.paper" : "#fff",
                      p: 1.5,
                    }}
                  >
                    <Grid container spacing={1}>
                      {submenu.checkedPermission?.map((perm) => {
                        const keys = Object.keys(perm);
                        const permssion = keys[0].split("-");
                        return (
                          <Grid item xs={12} sm={6} md={4} key={`${keys[0]}`}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={checkedPermissions.includes(`${keys[0]}`)}
                                  onChange={() =>
                                    handlePermissionChange(permssion[0], permssion[1])
                                  }
                                  size="small"
                                />
                              }
                              label={<Typography variant="caption">{permssion[1]}</Typography>}
                            />
                          </Grid>
                        );
                      })}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ))}
            </AccordionDetails>
          </Accordion>
        ))}
      </CardContent>
    </Card>
  );
};

export default MenuCard;
